export const GET_REWARDS_TERMS_AND_CONDITIONS = 'GET_REWARDS_TERMS_AND_CONDITIONS';
export const GET_REWARDS_TERMS_AND_CONDITIONS_SUCCESS = 'GET_REWARDS_TERMS_AND_CONDITIONS_SUCCESS';
export const GET_REWARDS_TERMS_AND_CONDITIONS_ERROR = 'GET_REWARDS_TERMS_AND_CONDITIONS_ERROR';

